import React, { useEffect, useRef, useState } from "react";
import { BsBellFill } from "react-icons/bs";
import {
  approveRequest,
  fetchNotifications,
  fetchUnreadCount,
  markAllNotificationsAsRead,
  rejectRequest,
} from "../../services/user/api";
import "./ClientNotificationTopBell.css";
import { toast } from "react-toastify";

const ClientNotificationTopBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [open, setOpen] = useState(false);
  const notificationRef = useRef(null);

  const approvalTitles = [
    "PERSONAL_DETAILS",
    "ADDRESS_DETAILS",
    "EDUCATION_DETAILS",
    "EMPLOYMENT_DETAILS",
  ];

  const handleApprove = async (item) => {
    try {
      const updateRequest = {
        userId: Number(item.id), // candidate/user id
        requestId: Number(item.redirectUrl), // request id
      };

      const response = await approveRequest(updateRequest);

      toast.success(response.data.message || "Request approved successfully.");

      await loadNotifications();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to approve request.",
      );
    }
  };

  const handleReject = async (item) => {
    try {
      const updateRequest = {
        userId: Number(item.id),
        requestId: Number(item.redirectUrl),
      };

      const response = await rejectRequest(updateRequest);

      toast.success(response.data.message || "Request rejected successfully.");

      await loadNotifications();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to reject request.");
    }
  };

  const loadNotifications = async () => {
    try {
      const data = await fetchNotifications();
      setNotifications(data || []);
    } catch (err) {}
  };

  const loadUnreadCount = async () => {
    try {
      const count = await fetchUnreadCount();
      setUnreadCount(count || 0);
    } catch (err) {}
  };

  useEffect(() => {
    // Load immediately
    loadUnreadCount();
  }, []);

  const handleBellClick = async () => {
    if (!open) {
      await loadNotifications();

      try {
        await markAllNotificationsAsRead();
        setUnreadCount(0);
      } catch (err) {}
    }

    setOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // add the event listener here
  useEffect(() => {
    const handleNewNotification = (event) => {
      const notification = event.detail;
      console.log(notification);
      setNotifications((prev) => [notification, ...prev]);

      setUnreadCount((prev) => prev + 1);
    };

    window.addEventListener("client-notification", handleNewNotification);

    return () =>
      window.removeEventListener("client-notification", handleNewNotification);
  }, []);

  return (
    <div className="notification-container" ref={notificationRef}>
      <div className="notification-bell" onClick={handleBellClick}>
        <BsBellFill />

        {unreadCount > 0 && (
          <span className="notification-count">{unreadCount}</span>
        )}
      </div>

      {open && (
        <div className="notification-dropdown">
          <div className="notification-header">Notifications</div>

          <div className="notification-list">
            {notifications.length === 0 ? (
              <div className="notification-empty">
                No notifications available
              </div>
            ) : (
              notifications.map((item, index) => {
                const showApprovalButtons = approvalTitles.includes(item.title);

                return (
                  <div className="notification-item" key={index}>
                    <p className="notification-title">
                      <strong>{item.title}</strong>
                    </p>

                    <p>{item.message}</p>

                    <span>
                      {new Date(
                        item.createdAt || item.notificationTime,
                      ).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </span>

                    {showApprovalButtons && (
                      <div className="notification-actions">
                        <button
                          className="approve-btn"
                          onClick={() => handleApprove(item)}
                        >
                          Approve
                        </button>

                        <button
                          className="reject-btn"
                          onClick={() => handleReject(item)}
                        >
                          Reject
                        </button>
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientNotificationTopBell;
